/*
 * Copyright 2021 EquiSoft
 */
import { createRoot } from "react-dom/client";
import AppConfig from "./AppConfig";
import { IsDevelopment, IsGlobalConfigLocalMode } from "./core/configuration";
import { SiteConfigurationProvider } from "@dit/ui-configurations/configurations";
import { AppNotLoaded } from "./components/pages/AppNotLoaded";
import { AsyncRoot } from "./AsyncRoot";
import { GlobalConfigDefinition } from "./core/globalConfig";

declare global {
    interface Window {
        APP_VERSION: typeof APP_VERSION;
        INFORMATIONAL_VERSION: typeof INFORMATIONAL_VERSION;
    }
}

window.APP_VERSION = process.versions.app; /* Webpack magically substitutes these in the generates output */
window.INFORMATIONAL_VERSION = process.versions.informational;

const root = createRoot(document.getElementById("root"));
AppConfig().then(appConfig => {
    root.render(
        appConfig?.hasError ? (
            <AppNotLoaded errorStatusCode={appConfig.errorStatusCode} />
        ) : appConfig !== null ? (
            <AsyncRoot
                baseConfig={appConfig.baseConfig as GlobalConfigDefinition}
                configurationProvider={IsDevelopment && IsGlobalConfigLocalMode ? SiteConfigurationProvider.local : SiteConfigurationProvider.local}
            />
        ) : null
    );
});
